import React from "react";

export default function Content() {
  return <React.Fragment />;
}

Content.displayName = "OverflowMenu.Content";
